import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import * as actions from '../actions';
import sampleCombine from 'xstream/extra/sampleCombine';
import delay from 'xstream/extra/delay';
import HEADER_FUNCTIONS from '../utils/functions/headers';
import GENERAL_FUNCTIONS from '../utils/functions/functions';

const REQUEST_QUESTION_TYPES = 'requestQuestionTypes';

export function requestQuestionsTypes(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(action => {
        return action.type === ActionTypes.FETCH_QUESTION_TYPES;
    })
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: GENERAL_FUNCTIONS.getBaseURL() + 'api/QuestionType',
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_QUESTION_TYPES,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_QUESTION_TYPES)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchQuestionTypesSuccess(response)
                : actions.fetchQuestionTypesFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
